import React from "react";
import PropTypes from "prop-types";

const PageContent = (props) => {
	return (
		<section className="o-reactpage__main">
			{props.children}
		</section>
	);
};

PageContent.propTypes = {
	children: PropTypes.node.isRequired
};

export default PageContent;
